<div class="p-4 d-flex justify-content-between align-items-center">
  <h4>Edit Property</h4>
</div>

<div mat-dialog-content>
  <form *ngIf="propertyForm" [formGroup]="propertyForm" class="needs-validation">
    <div class="row mb-3 p-fluid">
      <div class="col-md-12 mb-3">
        <label for="isActive" class="mr-1">Is Active</label>
        <p-checkbox formControlName="isActive" name="isActive" [binary]="true"></p-checkbox>
      </div>
      <div class="col-md-6">
        <label for="name" class="form-label">Name</label>
        <input
          id="name"
          type="text"
          class="form-control"
          placeholder="Property name"
          formControlName="name"
        />
      </div>
      <div class="col-md-6">
        <label for="destinationId" class="form-label">Destination</label>
        <p-select
          formControlName="destinationId"
          [options]="destinationOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Select destination"
          class="w-100">
        </p-select>
      </div>
    </div>

    <div class="row mb-3 p-fluid">
      <div class="col-md-6">
        <label for="brand" class="form-label">Brand</label>
        <p-select
          formControlName="brand"
          [options]="brandOptions"
          placeholder="Select brand"
          class="w-100">
        </p-select>
      </div>
      <div class="col-md-6">
        <label for="type" class="form-label">Type</label>
        <p-select
          formControlName="type"
          [options]="typeOptions"
          placeholder="Select type"
          class="w-100">
        </p-select>
      </div>
    </div>


    <div class="row mb-3 p-fluid">
      <div class="col-md-6">
        <label for="stars" class="form-label">Stars</label>
        <p-select
          formControlName="stars"
          [options]="starsOptions"
          placeholder="Select rate (stars)"
          class="w-100">
        </p-select>
      </div>
      <div class="col-md-6">
        <label for="type" class="form-label">Number Of Stars</label>
        <p-select
          formControlName="numberOfStars"
          [options]="numberOfStarsOptions"
          placeholder="Select number of stars"
          class="w-100">
        </p-select>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-4">
        <label for="family" class="mr-1">Family</label>
        <p-checkbox formControlName="family" name="family" [binary]="true"></p-checkbox>
      </div>
      <div class="col-md-4">
        <label for="couples" class="mr-1">Couples</label>
        <p-checkbox formControlName="couples" name="couples" [binary]="true"></p-checkbox>
      </div>
      <div class="col-md-4">
        <label for="generic" class="mr-1">Generic</label>
        <p-checkbox formControlName="generic" name="generic" [binary]="true"></p-checkbox>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-4">
        <label for="highSpenders" class="mr-1">High Spenders</label>
        <p-checkbox formControlName="highSpenders" name="highSpenders" [binary]="true"></p-checkbox>
      </div>
      <div class="col-md-4">
        <label for="lowSpenders" class="mr-1">Low Spenders</label>
        <p-checkbox formControlName="lowSpenders" name="lowSpenders" [binary]="true"></p-checkbox>
      </div>
      <div class="col-md-4">
        <label for="alpine" class="mr-1">Alpine</label>
        <p-checkbox formControlName="alpine" name="alpine" [binary]="true"></p-checkbox>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-4">
        <label for="bike" class="mr-1">Bike</label>
        <p-checkbox formControlName="bike" name="bike" [binary]="true"></p-checkbox>
      </div>
      <div class="col-md-4">
        <label for="pet" class="mr-1">Pets</label>
        <p-checkbox formControlName="pet" name="pets" [binary]="true"></p-checkbox>
      </div>
      <div class="col-md-4">
        <label for="naturisti" class="mr-1">Naturists</label>
        <p-checkbox formControlName="naturisti" name="naturisti" [binary]="true"></p-checkbox>
      </div>
    </div>

    <div class="mb-3">
      <label for="imageUrl" class="form-label">Min Price: </label>
      <input type="text" class="form-control" id="imageUrl" formControlName="minPrice">
    </div>

    <div class="mb-3">
      <label for="map" class="form-label">Map: </label>
      <input type="text" class="form-control" id="map" formControlName="mapUrl">
    </div>

    <div class="mb-3">
      <label for="imageUrl" class="form-label">Image URL:</label>
      <input type="text" class="form-control" id="imageUrl" formControlName="imageUrl">
      <!--      <div *ngIf="propertyForm.get('imageUrl')?.invalid && propertyForm.get('imageUrl')?.touched" class="text-danger">-->
      <!--        Image URL is required.-->
      <!--      </div>-->
    </div>

    <!--    urls:-->
    <div class="col-12" [formGroupName]="'urls'">
      <div class="p-1 hover:bg-gray-100 d-flex align-items-center" (click)="toggleSection('urls')"
           style="cursor:pointer;">
        <label class="form-label">URLs:</label>
        <i class="pi mb-1" [ngClass]="getSectionStatus('urls') ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
      </div>
      <div *ngIf="getSectionStatus('urls')" class="usp-content mt-2">

        <div *ngFor="let lang of  langs" class="mb-2">
          <label class="font-bold form-label text-uppercase">{{ lang }}:</label>
          <input type="text"
                 pInputText
                 [pTooltip]="$safeNavigationMigration(propertyForm.get('urls.' + lang)?.value)"
                 tooltipPosition="top"
                 [formControlName]="lang"
                 class="form-control"
                 [placeholder]="'URL for ' + lang.toUpperCase()">
        </div>
      </div>
    </div>

    <div class="col-12" [formGroupName]="'bookingUrls'">
      <div class="p-1 hover:bg-gray-100 d-flex align-items-center" (click)="toggleSection('bookingUrls')"
           style="cursor:pointer;">
        <label class="form-label">Booking URLs:</label>
        <i class="pi mb-1" [ngClass]="getSectionStatus('bookingUrls') ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
      </div>
      <div *ngIf="getSectionStatus('bookingUrls')" class="usp-content mt-2">

        <div *ngFor="let lang of  langs" class="mb-2">
          <label class="font-bold form-label text-uppercase">{{ lang }}:</label>
          <input type="text"
                 pInputText
                 [pTooltip]="$safeNavigationMigration(propertyForm.get('bookingUrls.' + lang)?.value)"
                 tooltipPosition="top"
                 [formControlName]="lang"
                 class="form-control"
                 [placeholder]="'Booking URL for ' + lang.toUpperCase()">
        </div>
      </div>
    </div>

    <!--    -->
    <!-- USP -->
    <div class="mb-3">
      <div class="col-12" [formGroupName]="'uniqueSellingPoints'">
        <div class="p-1 hover:bg-gray-100 d-flex align-items-center" (click)="toggleSection('usp')"
             style="cursor:pointer;">
          <label class="form-label cursor-pointer">Unique Selling Points:</label>
          <i class="pi mb-1" [ngClass]="getSectionStatus('usp') ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </div>
        <div *ngIf="getSectionStatus('usp')" class="usp-content mt-2">
          <div *ngFor="let lang of langs" class="mb-3">
            <label class="font-bold form-label text-uppercase">{{ lang }}:</label>
            <div [formArrayName]="lang">
              <div *ngFor="let usp of getUspArray(lang).controls; let i = index" [formGroupName]="i" class="mb-2">
                <label for="title" class="form-label">Title:</label>
                <input type="text"
                       pInputText
                       [pTooltip]="$safeNavigationMigration(usp.get('title')?.value)"
                       tooltipPosition="top"
                       class="form-control mb-1"
                       formControlName="title"
                       placeholder="Title">
                <label for="order" class="form-label">Order:</label>
                <input type="number" class="form-control" formControlName="order" placeholder="Order">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!--    <div class="mb-3">-->
    <!--      <label for="urlBooking" class="form-label">Booking URL</label>-->
    <!--      <input type="url" class="form-control" id="urlBooking" formControlName="urlBooking" required>-->
    <!--      <div *ngIf="propertyForm.get('urlBooking')?.invalid && propertyForm.get('urlBooking')?.touched"-->
    <!--           class="text-danger">-->
    <!--        Booking URL is required and must be valid.-->
    <!--      </div>-->
    <!--    </div>-->

  </form>
</div>
<div mat-dialog-actions class="d-flex justify-content-end">
  <button mat-button (click)="onCancel()" color="warn">Cancel</button>
  <button mat-button (click)="onSave()" color="primary" [disabled]="propertyForm?.invalid">Save</button>
</div>
